// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.lGNdM9p5slCMaa {
  display: block;
  position: absolute;
  z-index: 0;
  top: var(--ds-space-0, 0);
  left: var(--ds-space-0, 0);
  width: 64px;
  height: 64px;
  transition: transform 85ms ease-in, opacity 85ms ease-in;
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
}
.lGNdM9p5slCMaa:hover {
  z-index: 1;
}
.lGNdM9p5slCMaa:hover .nWehxy740fBWTm .iNWJEnMkUXMgeU {
  display: block;
  top: var(--ds-space-negative-050, -4px);
  left: var(--ds-space-negative-050, -4px);
  width: 72px;
  height: 72px;
  border-radius: var(--ds-border-radius-300, 10px);
  background-color: var(--ds-surface-raised-hovered, #f1f2f4);
}
/* Shadow for peel */
.nWehxy740fBWTm {
  position: relative;
}
.iNWJEnMkUXMgeU,
.jfmWiPrJPozs9T,
.pdeVW0SJUTLRAr,
.ebqZGL2lpVN3W_,
.oAnWLeQMvcYANS {
  position: absolute;
  top: var(--ds-space-0, 0);
  left: var(--ds-space-0, 0);
  width: 64px;
  height: 64px;
  color: transparent;
}
.iNWJEnMkUXMgeU:-moz-loading,
.jfmWiPrJPozs9T:-moz-loading,
.pdeVW0SJUTLRAr:-moz-loading,
.ebqZGL2lpVN3W_:-moz-loading,
.oAnWLeQMvcYANS:-moz-loading {
  visibility: hidden;
}
.jfmWiPrJPozs9T {
  mask-repeat: no-repeat;
  mask-size: cover;
  opacity: 0.9;
}
.ebqZGL2lpVN3W_ {
  clip: rect(0 64px 64px 64px);
  transform: scaleX(1) skewY(0deg);
  backface-visibility: hidden;
  transition: transform 0.3s ease, opacity 0.3s ease-in, clip 0.3s ease-in;
  opacity: 0;
  filter: brightness(0);
}
.pdeVW0SJUTLRAr {
  clip: rect(0 64px 64px 0);
  transition: clip 0.3s ease-in;
}
.oAnWLeQMvcYANS {
  clip: rect(0 64px 64px 64px);
  transform: translateX(0) perspective(300px) rotateY(0deg) translateX(0);
  transform-style: preserve-3d;
  transition: transform 0.3s ease-in, filter 0.1s ease-in, clip 0.3s ease-in;
  filter: brightness(1);
}
.lGNdM9p5slCMaa.tUt9_4WD8dZnRS .nWehxy740fBWTm .pdeVW0SJUTLRAr {
  clip: rect(0 16px 64px 0);
}
.lGNdM9p5slCMaa.tUt9_4WD8dZnRS .nWehxy740fBWTm .ebqZGL2lpVN3W_ {
  clip: rect(0 64px 64px 16px);
  transform: scaleX(0.4) skewY(8deg);
  opacity: 0.2;
}
.lGNdM9p5slCMaa.tUt9_4WD8dZnRS .nWehxy740fBWTm .oAnWLeQMvcYANS {
  clip: rect(0 64px 64px 16px);
  transform: translateX(-16px) perspective(300px) rotateY(-70deg) translateX(16px);
  filter: brightness(1.2);
}
.JqTDC7egxqUctr {
  position: absolute;
  top: var(--ds-space-0, 0);
  right: var(--ds-space-0, 0);
  padding: var(--ds-space-050, 4px);
  border-radius: var(--ds-border-radius-circle, 50%);
  opacity: 0;
  background-color: var(--ds-background-input, #ffffff);
  line-height: 1em;
}
.JqTDC7egxqUctr:hover {
  background-color: var(--ds-background-input-hovered, #f7f8f9);
}
.JqTDC7egxqUctr:active {
  background-color: var(--ds-background-input-pressed, #ffffff);
}
.lGNdM9p5slCMaa:hover .JqTDC7egxqUctr {
  opacity: 1;
}
.a4MnpDW3GTqpio {
  transition: 0s z-index 0.3s step-start, 0s all 0.3s linear;
}
.lGNdM9p5slCMaa:hover .a4MnpDW3GTqpio {
  transition: 0s z-index 0.3s step-end, 0s all 0.3s linear;
}
.a4MnpDW3GTqpio .JqTDC7egxqUctr {
  transition: 0s z-index 0.3s step-end, 0s opacity 0.3s linear;
}
.lGNdM9p5slCMaa:hover .a4MnpDW3GTqpio .JqTDC7egxqUctr {
  transition: 0s z-index 0.3s step-start, opacity 0.3s linear;
  opacity: 1;
}
.a4MnpDW3GTqpio .iNWJEnMkUXMgeU {
  transition: 0s z-index 0.3s step-end, 0s all 0.3s linear;
}
`, ""]);
// Exports
export var sticker = `lGNdM9p5slCMaa`;
export var stickerRemoving = `nWehxy740fBWTm`;
export var highlight = `iNWJEnMkUXMgeU`;
export var residue = `jfmWiPrJPozs9T`;
export var fixed = `pdeVW0SJUTLRAr`;
export var shadow = `ebqZGL2lpVN3W_`;
export var peel = `oAnWLeQMvcYANS`;
export var stickerPeeling = `tUt9_4WD8dZnRS`;
export var removeStickerButton = `JqTDC7egxqUctr`;
export var cardBackSticker = `a4MnpDW3GTqpio`;
export default ___CSS_LOADER_EXPORT___;
